export enum StepStatus {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  FAILED = 'failed',
}
